export const PPCManagmentModalConfig = {
    REVIEW_STATUS: 3,
    DRAFT_STATUS: 4,
    LIVE_STATUS: 1,
    REJECTED_STATUS: 2,
    HTR_STAGE_PUBLISHER_ID: 10,
    HTR_PUBLISHER_ID: 67,
    DEFAULT_ID: 1
}